import { GraniteSelect, OptionType } from 'components/Select/Select';

export const switchTableOptions = [
  { label: 'View by service', value: 'service' },
  { label: 'View by account', value: 'account' },
];

const SwitchTable = ({
  setTableView,
  selectedTableView,
}: {
  setTableView: (selectedTableView: OptionType) => void;
  selectedTableView: OptionType;
}) => {
  return (
    <GraniteSelect
      options={switchTableOptions}
      className="!box-border w-full md:max-w-[190px]"
      isSearchable={false}
      value={selectedTableView}
      onChange={(selectedItem) => {
        if (selectedItem) {
          setTableView(selectedItem);
        }
      }}
      classNames={{
        control: () => 'border-button-stroke-secondary-default',
        singleValue: () => 'text-center md:text-left',
      }}
    />
  );
};

export default SwitchTable;
